import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useCompanyDimensionTreeWithRoot } from '../queries/useCompanyDimensionTreeWithRoot'
import { Dimension } from '../types/Dimension'
import TreeCheckboxFilter from '../../../shared/components/custom/TreeCheckboxFilter'
import { StringTitleTreeNode } from '../../../shared/components/custom/CheckboxTree'

interface DimensionTreeCheckboxFilterProps {
  value?: string[]
  onChange?: (values: string[]) => void
  checkOnSearch?: boolean
}

/** Convert a Dimension[] into StringTitleTreeNode[] (key = dimensionId, title = name, children recursed) for CheckboxTree */
const toTreeData = (dimensions: Dimension[]): StringTitleTreeNode[] =>
  dimensions.map(d => ({
    key: d.dimensionId,
    title: d.name,
    children: d.children ? toTreeData(d.children) : undefined
  }))

const DimensionTreeCheckboxFilter: React.FC<DimensionTreeCheckboxFilterProps> = ({
  value = [],
  onChange,
  checkOnSearch = false
}) => {
  const { t } = useTranslation()
  const { data: dimensionTreeWithRoot, isLoading } = useCompanyDimensionTreeWithRoot()

  const treeData = useMemo(() => {
    if (!dimensionTreeWithRoot) return []
    return toTreeData([dimensionTreeWithRoot])
  }, [dimensionTreeWithRoot])

  if (isLoading) {
    return <div style={{ padding: '8px' }}>{t('global:loading')}</div>
  }

  return <TreeCheckboxFilter treeData={treeData} value={value} onChange={onChange} checkOnSearch={checkOnSearch} />
}

export default DimensionTreeCheckboxFilter
